<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>外部出库列表</el-breadcrumb-item>
    </el-breadcrumb>

      <el-button size="mini" plain @click="showSendPurchaseDialog(null,1)"
                 v-if="authorities.includes('storage.outstock.new')">新建出库单</el-button>
      <el-date-picker
        v-model="purchaseRequest.selectDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="mini"
        @change="queryPurchase"
      >
      </el-date-picker>
      <el-select v-model="selectOrgId" clearable size="mini" style="width: 150px" value filterable placeholder="请选择门店" class="select"
                 @change="getShopSelect">
        <el-option
          v-for="org in outShop"
          :key="org.id"
          :label="org.outOrgName"
          :value="org.id">
        </el-option>
      </el-select>
      <br>
      <span style="font-size: 13px;color: #3a8ee6">合计金额：{{totalMoney}} 元</span>
      <el-table height="550px" :data="outOrgProductList" fit border stripe="stripe"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}"
                :cell-style="orderStateColor">
        <el-table-column
          label="操作"
          fixed="fixed"
          align="center"
          width="100">
          <template slot-scope="scope" >
            <div style="display: flex;justify-content: space-evenly">
              <el-link icon="iconfont icon-bianji" v-if="authorities.includes('storage.outstock.update')" size="mini" type="primary"
                       @click="showSendPurchaseDialog(scope.row,2)"></el-link>
              <div v-if="authorities.includes('storage.outstock.cancel')">
                <el-link type="danger" v-if="scope.row.state === 4 || scope.row.state === 2" :disabled="true" icon="iconfont icon-zuofei"></el-link>
                <el-link type="danger" v-if="scope.row.state === 1"  icon="iconfont icon-zuofei" @click="cancelOutOrgPurchase(scope.row)"></el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseDate"
          label="出库日期"
          align="center">
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="center"
          :formatter="stateFormatter">
        </el-table-column>
        <el-table-column
          prop="purchaseMoney"
          label="产品费用"
          align="center">
        </el-table-column>
        <el-table-column
          prop="buyerName"
          label="出库人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="inOrgName"
          label="接收机构"
          align="center">
        </el-table-column>
        <el-table-column
          prop="outOrgName"
          label="出库机构"
          align="center">
        </el-table-column>
        <el-table-column
          prop="purchaseNo"
          label="出库单号"
          align="center">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>

    <!-- 创建出库单 -->
    <el-dialog
      title="外部出库单"
      :visible.sync="sendDialogVisible"
      width="60%"
      @close="closeSendPurchaseDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="height: 30px;margin-top: 5px;display: flex;justify-content: space-between">
        <div>
          <span >选择机构： </span>
          <el-select v-model="purchase.inOrgId" size="mini" style="width: 300px" value filterable placeholder="请选择门店" class="select"
                     @change="getShop">
            <el-option
              v-for="org in shopList"
              :key="org.id"
              :label="org.outOrgName"
              :value="org.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <span >出库金额： </span>
          <el-input style="width: 300px" disabled v-model="purchase.purchaseMoney" size="mini" />
        </div>
      </div>

      <div style="margin-top:5px;text-align: right">
        <el-button size="mini" plain @click="showProductDrawer">添加明细</el-button>
      </div>
      <el-table :data="selectProductList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="300"
                :row-style="{height: '0'}">
        <el-table-column
          align="center"
          prop="userName"
          label="操作" width="100">
          <template slot-scope="scope">
            <el-link type="danger" icon="el-icon-delete"
                     @click="deleteConsumptionShowList(scope.$index, selectProductList)"></el-link>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="产品名称" width="250">
        </el-table-column>
        <el-table-column
          align="center"
          label="数量" width="150" v-if="operateType === 1">
          <template slot-scope="scope">
            <el-input v-model="scope.row.num" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"
                      @change="getTotal"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="数量" width="150" v-if="operateType === 2">
          <template slot-scope="scope">
            <el-input v-model="scope.row.num" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"
                      @change="modifyTotal"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="出库单价" width="150" v-if="operateType === 1">
          <template slot-scope="scope">
            <div v-if="currentOrgPurchaseLevel === 1">
              <el-input v-model="scope.row.oneLevelPrice" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"
                        @change="getTotal"></el-input>
            </div>
            <div v-if="currentOrgPurchaseLevel === 2">
              <el-input v-model="scope.row.twoLevelPrice" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"
                        @change="getTotal"></el-input>
            </div>
            <div v-if="currentOrgPurchaseLevel === 3">
              <el-input v-model="scope.row.threeLevelPrice" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"
                        @change="getTotal"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="出库单价" width="150" v-if="operateType === 2">
          <template slot-scope="scope">
            <el-input v-model="scope.row.price" size="mini" onkeyup="value=value.replace(/[^\d]/g,'')"
                      @change="modifyTotal"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="小计" v-if="operateType === 1">
          <template slot-scope="scope">
            <div v-if="currentOrgPurchaseLevel === 1">
              {{ (scope.row.oneLevelPrice * scope.row.num).toFixed(1)}}
            </div>
            <div v-if="currentOrgPurchaseLevel === 2">
              {{ (scope.row.twoLevelPrice * scope.row.num).toFixed(1)}}
            </div>
            <div v-if="currentOrgPurchaseLevel === 3">
              {{ (scope.row.threeLevelPrice * scope.row.num).toFixed(1)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="小计" v-if="operateType === 2">
          <template slot-scope="scope">
            {{ (scope.row.price * scope.row.num).toFixed(1)}}
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeSendPurchaseDialog">取 消</el-button>
        <el-button size="mini" @click="createSend">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择产品 -->
    <el-drawer
      title="产品列表"
      size="60%"
      :visible.sync="productDrawerVisible"
      :before-close="closeProductDrawer"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
<!--            <el-input size="mini"-->
<!--                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
<!--                      placeholder="输入关键字进行过滤"-->
<!--                      v-model="consumptionTypeFilterText">-->
<!--            </el-input>-->
            <el-card class="box-card">
              <el-tree
                :data="consumptionTypeList"
                :props="consumptionTypeProps"
                @node-click="consumptionTypeHandleNodeClick"
                :highlight-current="true"
                node-key="id"
                :filter-node-method="consumptionTypeFilterNode"
                default-expand-all
                ref="serviceTree"
              >
              </el-tree>
            </el-card>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-card class="box-card">
<!--            <el-input size="mini"-->
<!--                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
<!--                      placeholder="输入关键字进行过滤"-->
<!--                      v-model="queryProductText"-->
<!--                      @keyup.enter.native="queryConsumption"-->
<!--            >-->
<!--            </el-input>-->
            <el-table :height="getTableHeight" :data="consumptionList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                prop="userName"
                fixed="fixed"
                label="操作" width="160">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.num"
                                   size="mini"
                                   @change="orderNumHandleChange(scope.row)" :min="0" :max="1000" label="描述文字"></el-input-number>
                </template>e
              </el-table-column>
              <el-table-column
                align="center"
                prop="consumptionName"
                fixed="fixed"
                label="产品名称">
              </el-table-column>
              <el-table-column
                align="center"
                label="出库价格">
                <template slot-scope="scope">
                  <div v-if="currentOrgPurchaseLevel === 1">
                    {{scope.row.oneLevelPrice}}
                  </div>
                  <div v-if="currentOrgPurchaseLevel === 2">
                    {{scope.row.twoLevelPrice}}
                  </div>
                  <div v-if="currentOrgPurchaseLevel === 3">
                    {{scope.row.threeLevelPrice}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="practicalNum"
                label="库存数量" >
              </el-table-column>
            </el-table>
            <div style="margin-top: 3px;">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage1"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal1">
              </el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      orgLevel:'',
      userId:'',
      authorities:'',
      outShop:'',
      shopList:[],
      currentOrgPurchaseLevel:'',
      outOrgProductList:[],
      queryText:'',
      sendDialogVisible:false,
      productDialogVisible:false,
      productList:[],
      consumptionShowList:[],
      multipleSelection:[],
      selectProductList:[],
      purchase:{
        id:'',
        purchaseDate:'',
        productNo:'',
        purchaseNo:'',
        purchaseMoney:'',
        buyer:'',
        inOrgId:'',
        orgName:'',
        creator:'',
        buyerName:'',
        consumptions:[],
        outsidePurchaseDetails:[]
      },
      productDrawerVisible:false,
      sendDetailDialogVisible:false,
      consumptionTypeList:[],
      consumptionTypeFilterText:'',
      consumptionTypeProps:{
        label: 'consumptionTypeName',
        children: 'children'
      },
      consumptionList:[],
      stateText:[
        {state:1, name:'已出库'},
        {state:2, name:'已作废'},
      ],
      detailOrModify:false,
      detailDialogTitle:'',
      operateType:'',
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      type:'',
      consumptionTypeId:'',
      queryProductText:'',

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,
      purchaseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        outOrgId:''
      },
      totalMoney:'',
      selectOrgId:'',
      createSendDoubleClick:false,
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        productTypeId:'',
        consumptionId:''
      },
    }
  },
  methods:{
    async queryPurchase(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.orgId = this.currentOrgId;
      this.purchaseRequest.inOrgId = this.purchase.inOrgId;
      this.purchaseRequest.outOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/outOrgPurchase/query`, this.purchaseRequest)
      this.outOrgProductList = res.data.list;
      this.pageTotal = res.data.total;

      const {data:res1} = await this.$http.post(`/outOrgPurchase/query/total`, this.purchaseRequest)
      if (res1.data !== null){
        this.totalMoney = res1.data.totalMoney;
      }

      const {data:res2} = await this.$http.post(`load/outOrg/orgList/`, this.purchaseRequest);
      if (res2.data !== null){
        this.outShop = res2.data;
      }
    },
    getShopSelect(data){
      this.purchaseRequest.inOrgId = data;
      this.queryPurchase();
    },
    async showSendPurchaseDialog(data,type){
      this.operateType = type
      if (type === 1){
          this.purchase.purchaseMoney = '';
          this.purchase.productNo = '';
          this.purchase.consumptions = '';
          this.purchase.consumptions = [];
          this.purchase.inOrgId = '';
          this.selectProductList = []

      }
      if (type === 2){
        const {data:res} = await this.$http.get(`/outOrgPurchase/id/${data.id}`);
        this.purchase = res.data;
        this.currentOrgPurchaseLevel = res.data.orgPurchaseLevel;
        this.selectProductList = res.data.outsidePurchaseDetails;
      }
      this.sendDialogVisible = true;
    },
    closeSendPurchaseDialog(){
      this.sendDialogVisible = false;
      this.getTotal();
    },
    //选择机构
    getShop(data){
      this.purchase.inOrgId = data;
      for (let i = 0; i < this.shopList.length; i++) {
        if (this.shopList[i].id === data){
          this.currentOrgPurchaseLevel = this.shopList[i].purchaseLevel;
        }
      }
    },
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#EA1B28';
      }
    },
    showProductDrawer(){
      //如果没有选择接收机构，返回。
      if (this.purchase.inOrgId === ''){
        this.$message.warning("请选择接收机构！")
      } else {
        this.loadProductTypeList();
        this.productDrawerVisible = true;
      }
    },
    //加载产品分类
    async loadProductTypeList(){
      this.consumptionList = [];
      //作为出库方，要查询出库方的产品类目
      const {data:res} = await this.$http.get(`/consumptionType/purchase/orgId/${this.currentOrgId}`)
      this.consumptionTypeList = res.data;
    },
    modifyTotal(){
      let purchaseMoney = 0;
      this.selectProductList.map((item) =>{
        purchaseMoney += item.price * item.num - 0;
      })
      this.purchase.purchaseMoney = purchaseMoney;
    },
    closeProductDrawer(){
      this.getTotal();
      this.productDrawerVisible = false;
    },
    getTotal(){
      let purchaseMoney = 0;
      for (let i = 0; i < this.selectProductList.length; i++) {
        if (this.operateType === 1){
          if(this.currentOrgPurchaseLevel === 1){
            purchaseMoney += this.selectProductList[i].oneLevelPrice * this.selectProductList[i].num;
            // this.selectProductList[i].price = this.selectProductList[i].twoLevelPrice;
          }
          if(this.currentOrgPurchaseLevel === 2){
            purchaseMoney += this.selectProductList[i].twoLevelPrice * this.selectProductList[i].num;
            // this.selectProductList[i].price = this.selectProductList[i].twoLevelPrice;
          }
          if (this.currentOrgPurchaseLevel === 3){
            purchaseMoney += this.selectProductList[i].threeLevelPrice * this.selectProductList[i].num;
            // this.selectProductList[i].price = this.selectProductList[i].threeLevelPrice;
          }
        }
        if (this.operateType === 2){
          if(this.purchase.orgPurchaseLevel === 1){
            purchaseMoney += this.selectProductList[i].oneLevelPrice * this.selectProductList[i].num;
            // this.selectProductList[i].price = this.selectProductList[i].twoLevelPrice;
          }
          if(this.purchase.orgPurchaseLevel === 2){
            purchaseMoney += this.selectProductList[i].twoLevelPrice * this.selectProductList[i].num;
            // this.selectProductList[i].price = this.selectProductList[i].twoLevelPrice;
          }
          if (this.purchase.orgPurchaseLevel === 3){
            purchaseMoney += this.selectProductList[i].threeLevelPrice * this.selectProductList[i].num;
            // this.selectProductList[i].price = this.selectProductList[i].threeLevelPrice;
          }
        }
      }
      this.purchase.purchaseMoney = purchaseMoney;
    },
    deleteConsumptionShowList(index,rows){
      rows.splice(index, 1);
      this.getTotal();
    },
    async createSend(){
      //1表示新增
      if (this.operateType === 1){
        if(this.purchase.inOrgId === ''){
          return this.$message.warning("请选择机构！")
        }
        if(this.selectProductList.length === 0){
          return this.$message.warning("请选择出库产品！")
        }
        this.purchase.buyer = this.userId;
        this.purchase.creator = this.userId;
        this.purchase.state = 1;
        this.purchase.outOrgId = this.currentOrgId;
        this.purchase.consumptions = this.selectProductList;
        this.purchase.orgPurchaseLevel = this.currentOrgPurchaseLevel;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
        const {data:res} = await this.$http.post(`/outOrgPurchase`, this.purchase);
        if (res.code === 200){
          this.$message.success("操作成功！")
        }
        // this.sendPurchaseList = res.data;
        await this.queryPurchase();
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
      //2表示更新
      if(this.operateType === 2){
        this.purchase.consumptions = this.selectProductList;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
        const {data:res} = await this.$http.put(`/outOrgPurchase`, this.purchase);
        if (res.code === 200) {
          this.$message.success("操作成功！")
        }
        // this.sendPurchaseList = res.data;
        await this.queryPurchase();
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
      this.closeSendPurchaseDialog();
    },
    async cancelOutOrgPurchase(row){
      row.state = 2;
      const {data:res} = await this.$http.post(`/outOrgPurchase/cancel`, row);
      if (res.code === 200){
        this.$message.success("操作成功！")
        // await this.loadOutOrgPurchaseList();

      }
      this.closeSendPurchaseDialog();
      await this.queryPurchase();
    },
    consumptionTypeHandleNodeClick(data){
      this.consumptionTypeId = data.consumptionTypeId;
      this.type = data.type;
      this.loadProductList();
    },
    //关键字查询产品的方法
    queryConsumption(){
      this.loadProductList();
    },
    async loadProductList(){
      await this.loadProductTotal();
      await this.loadProducts();
      // let text = 'null';
      // if (this.queryProductText !== ''){
      //   text = this.queryProductText;
      // }
      // const {data:res} = await this.$http.get(`/consumption/apply/type/${this.type}/typeId/${this.consumptionTypeId}/orgId/${this.currentOrgId}/queryConsumption/${text}/pageNum/${this.currentPage1}/pageSize/${this.pageSize1}`)
      // this.consumptionList = res.data.list;
      // this.pageTotal1 = res.data.total;
    },
    async loadProductTotal(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      // this.consumptionRequest.dateType = this.type;
      this.consumptionRequest.productTypeId = this.consumptionTypeId;
      this.consumptionRequest.pageNum = this.currentPage1;
      this.consumptionRequest.pageSize = this.pageSize1;
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = 'null';
      const {data:res} = await this.$http.post(`/load/count/consumption/apply`, this.consumptionRequest)
      this.pageTotal1 = res.totalPage;
    },
    async loadProducts(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      this.consumptionRequest.productTypeId = this.consumptionTypeId;
      this.consumptionRequest.pageNum = this.currentPage1;
      this.consumptionRequest.pageSize = this.pageSize1;
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = 'null';
      const {data:res} = await this.$http.post(`/load/list/consumption/apply`, this.consumptionRequest)
      this.consumptionList = res.data;
    },
    consumptionTypeFilterNode(value, data){
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    orderNumHandleChange(value){
      let result = true;
      for (let i = 0; i < this.selectProductList.length; i++) {
        if (this.selectProductList[i].productId === value.productId && value.num > 0){
          this.selectProductList[i].num = value.num;
          result = false;
        }

        if (this.selectProductList[i].productId === value.productId && value.num === 0){
          this.selectProductList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.selectProductList.push(value);
      }
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadOutOrgPurchaseList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadOutOrgPurchaseList();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadProductList();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadProductList();
    },
    async loadOutOrgList() {
      if (this.orgLevel == 1){
        const {data:res} = await this.$http.get(`/outOrg/oneLevel/areaId/${this.currentOrgId}`)
        this.shopList = res.data;
      } else {
        const {data:res} = await this.$http.get(`/outOrg/areaId/${this.currentOrgId}`)
        this.shopList = res.data;
      }
    },
    async loadOutOrgPurchaseList(){
      const {data:res} = await this.$http.get(`/outOrgPurchase/orgId/${this.currentOrgId}/pageNum/${this.currentPage}/pageSize/${this.pageSize}`)
      this.outOrgProductList = res.data.list;
      this.pageTotal = res.data.total;
    },
    //计算table高度(动态设置table高度)
    getTableHeight() {
      let tableH = 295; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },

  },
  watch: {
    consumptionTypeFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadOutOrgList();
    // this.loadOutOrgPurchaseList();
    this.queryPurchase();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}
/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OutStorage.vue